module.exports = __webpack_public_path__ + "img/柴胡.99f29f02.jpg";